import { render } from "./CustomTableField.vue?vue&type=template&id=6ed49400&ts=true"
import script from "./CustomTableField.vue?vue&type=script&lang=ts"
export * from "./CustomTableField.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__